import request from '@/utils/request'

// adq广告列表
export function adqAdvertList(params) {
  return request({
    url: `/ad_copy/adq_ads`,
    method: 'get',
    params
  })
}

// 广告主列表
export function advertiserList(params) {
  return request({
    url: `/ad_copy/account_list`,
    method: 'get',
    params
  })
}

// adq复制广告
export function copyAdqAdvert(data) {
  return request({
    url: `/ad_copy/copy_ad_adq`,
    method: 'post',
    data
  })
}

// adq复制列表
export function copyList(params = {}) {
  return request({
    url: `/ad_copy/adq_copy_list`,
    method: 'get',
    params
  })
}

export function shous(params = {}) {
  return request({
    url: `/ad_copy/get_account_campaign`,
    method: 'get',
    params
  })
}
// 终止复制任务
export function job_stop(data) {
  return request({
    url: `/job_stop`,
    method: 'post',
    data
  })
}
